import React, { useState } from 'react'
import style from './Filter.module.css'
import Tag from 'components/Buttons/Tag'
import CustomTag from 'components/Buttons/Tag/CustomTag'

interface FilterProps {
  setFilters: (keywords: string[]) => void
  suggestions?: string[]
}

const Filter: React.FC<FilterProps> = props => {
  const [inputValue, setInputValue] = useState('')
  const [tags, setTags] = useState<string[]>([])

  // Handles 'Enter' key presses in the input field
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      // Check if "Enter" key is pressed
      event.preventDefault() // Prevent the default form submission behavior

      const newTag = event.currentTarget.value.trim() // Get the trimmed value from the input

      // Only add non-empty and unique tags
      if (newTag !== '' && !tags.includes(newTag)) {
        // Add the value as a tag to the tags array
        setTags(prevTags => {
          const updatedTags = [...prevTags, newTag]
          props.setFilters(updatedTags)
          return updatedTags
        })
        setInputValue('') // Clear the input field after adding the tag
      }
    }
  }

  // Handles removing a tag
  const handleDeleteTag = (tagToDelete: string) => {
    setTags(prevArray => {
      // Filter out the tag to delete from the previous tags array
      const updatedTags = prevArray.filter(item => item !== tagToDelete)

      props.setFilters(updatedTags)
      // Update the local state with the filtered tags
      return updatedTags
    })
  }

  return (
    <div className={`${style.filter}`}>
      <div
        className={`${style.tag_box}`}
        role="listbox"
      >
        {tags.map((tag, index) => (
          <CustomTag
            key={index}
            closable
            onClose={() => handleDeleteTag(tag)}
            tabIndex={0}
            role="option"
          >
            {tag}
          </CustomTag>
        ))}
      </div>

      <input
        list="tags"
        type="text"
        placeholder="Filter"
        className={`${style.input}`}
        value={inputValue}
        onKeyDown={handleKeyDown}
        onChange={ev => setInputValue(ev.target.value)}
      />

      {/* Displaying the suggestions */}
      {props.suggestions && (
        <datalist id="tags">
          {props.suggestions.map((suggestion, index) => (
            <option
              key={index}
              value={suggestion}
              onClick={() => setInputValue(suggestion)}
            >
              {/* Capitalize the first letter */}
              {suggestion.charAt(0).toUpperCase() + suggestion.slice(1)}
            </option>
          ))}
        </datalist>
      )}
    </div>
  )
}

export default Filter
